module.exports = __webpack_public_path__ + "img/line-color.261566fc.svg";